/*eslint-env jquery*/
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { ready } from '../utils'

class Header extends Component {
    componentDidMount() {
        ready(() => {
            $('.navbar-toggle').on('click', function (event) {
                $(this).toggleClass('open');
                $('#navigation').slideToggle(400);
            });

            $('.navigation-menu>li').slice(-2).addClass('last-elements');

            $('.navigation-menu li.has-submenu a[href="#"]').on('click', function (e) {
                if ($(window).width() < 992) {
                    e.preventDefault();
                    $(this).parent('li').toggleClass('open').find('.submenu:first').toggleClass('open');
                }
            });
        })
    }
    render() {
        return (
            <div className="topbar">
                <div className="topbar-left">
                    <div className="text-center">
                        <Link to="/" className="logo"><span>MASAR</span></Link>
                    </div>
                </div>

                <nav className="navbar-custom">

                    <ul className="list-inline float-right mb-0">

                        <li className="list-inline-item dropdown notification-list">
                            <Link className="nav-link dropdown-toggle waves-effect waves-light nav-user" data-toggle="dropdown" to="#" role="button" aria-haspopup="false" aria-expanded="false">
                                <img src={this.props.user.avatar} alt="user" className="rounded-circle" />
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right profile-dropdown " aria-labelledby="Preview">

                                <div className="dropdown-item noti-title">
                                    <h5 className="text-overflow"><small>Welcome, {this.props.user.name.split(' ')[0]}</small> </h5>
                                </div>


                                <Link to="/profile" className="dropdown-item notify-item">
                                    <i className="mdi mdi-account"></i> <span>Profile</span>
                                </Link>

                                <Link to="/logout" className="dropdown-item notify-item">
                                    <i className="mdi mdi-logout"></i> <span>Logout</span>
                                </Link>

                            </div>
                        </li>

                    </ul>

                    <ul className="list-inline menu-left mb-0">
                        <li className="float-left">
                            <button className="button-menu-mobile open-left waves-light waves-effect">
                                <i className="mdi mdi-menu"></i>
                            </button>
                        </li>
                    </ul>

                </nav>

            </div>
        )
    }
}

const mapStateToProps = state => ({
    user: state.authReducer.user
});

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js